import React from 'react';
import { Box, Typography, Paper, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ReactComponent as CinchLogo } from '../cinch.svg';

/**
 * Not Found page for handling invalid routes
 */
const NotFoundPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      py: 4
    }}>
      <Box flexGrow={1} display="flex" alignItems="center">
        <Paper elevation={3} sx={{ width: '100%' }}>
          <Box p={4} textAlign="center">
            <Typography variant="h1" component="h1" gutterBottom>
              404
            </Typography>

            <Typography variant="h5" component="h2" gutterBottom>
              Page Not Found
            </Typography>

            <Typography paragraph>
              The page you are looking for doesn't exist or has been moved.
            </Typography>

            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(isAuthenticated ? '/landing' : '/setup')}
              sx={{ mt: 2 }}
            >
              Go to {isAuthenticated ? 'Landing' : 'Setup'} page
            </Button>
          </Box>
        </Paper>
      </Box>

      {/* Footer */}
      <Box pb={2} display="flex" justifyContent="center" alignItems="center">
        <Typography variant="body3" color="text.secondary">
          powered by
        </Typography>
        <Box ml={1} display="flex" alignItems="center">
          <CinchLogo
            width={75}
            style={{ marginRight: '4px' }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default NotFoundPage;